// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"Popup_closeButton__1EXGw","wrapper":"Popup_wrapper__2Rz9j"};